import { createFileRoute } from '@tanstack/react-router'
import PageRegisterVerification from '@/pages/account/register/verification'

export const Route = createFileRoute('/app/account/register/verification/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PageRegisterVerification />
}
